import { memo } from 'react'
import { ShoppingBagIcon, XMarkIcon } from '@heroicons/react/24/outline'

/**
 * ListingsEmptyNotice - Floating pill shown when the listings layer is on but empty
 * @atomic @idempotent
 */
const ListingsEmptyNotice = memo(function ListingsEmptyNotice({ t, user, onDismiss, onPostClick }) {
  return (
    <div className="fixed bottom-[230px] left-1/2 -translate-x-1/2 z-[900] pointer-events-auto w-[calc(100%-2rem)] max-w-sm">
      <div className="bg-white border border-amber-200 rounded-2xl shadow-lg overflow-hidden">
        {/* Header row */}
        <div className="flex items-center gap-2 px-4 pt-3 pb-1.5">
          <ShoppingBagIcon className="w-4 h-4 text-amber-500 flex-shrink-0" />
          <p className="text-sm font-semibold text-gray-800 flex-1 leading-tight">
            {t('listings.empty', 'Nothing available nearby right now')}
          </p>
          <button
            type="button"
            className="text-gray-400 hover:text-gray-600 p-1 rounded-lg transition-colors flex-shrink-0"
            onClick={onDismiss}
            onTouchEnd={(e) => { e.preventDefault(); onDismiss() }}
            aria-label="Dismiss"
          >
            <XMarkIcon className="w-4 h-4" />
          </button>
        </div>
        {/* Body */}
        <div className="flex items-center justify-between gap-3 px-4 pb-3">
          <p className="text-xs text-gray-500 flex-1">
            {t('listings.emptyBody', 'Be the first to share what you have available near you.')}
          </p>
          {user && (
            <button
              type="button"
              className="flex-shrink-0 px-3 py-1.5 bg-primary text-white text-xs font-semibold rounded-lg hover:bg-primary/90 active:scale-95 transition-all"
              onClick={onPostClick}
              onTouchEnd={(e) => { e.preventDefault(); onPostClick() }}
            >
              {t('listings.postButton', 'Post one')}
            </button>
          )}
        </div>
      </div>
    </div>
  )
})

export default ListingsEmptyNotice
